import React, { useEffect, useState } from "react";

const Footer = ({ lang }) => {
  const [html, setHtml] = useState("");
  useEffect(() => {
    let mounted = true;
    fetch(`/api/${lang}/legacy/layout`)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then(({ data } = {}) => {
        mounted && setHtml(data?.footer);
      });
    return () => (mounted = false);
  }, [lang]);

  return <div id="pied_page" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Footer;
